import type { ForwardRefExoticComponent, RefAttributes } from 'react'

import type { IconProps } from '@radix-ui/react-icons/dist/types'
import { generateVariantsWithPrefix, styled, textColors } from 'style'

export type RadixIcon = ForwardRefExoticComponent<
  IconProps & RefAttributes<SVGSVGElement>
>

export const IconStyled = styled('svg', {
  variants: {
    size: {
      xs: {
        size: 12,
      },
      sm: {
        size: 14,
      },
      md: {
        size: 16,
      },
      lg: {
        size: 18,
      },
      xl: {
        size: 20,
      },
      '2xl': {
        size: 24,
      },
      '3xl': {
        size: 28,
      },
      '4xl': {
        size: 32,
      },
      '5xl': {
        size: 38,
      },
    },
    color: {
      ...textColors,
    },
    colorHover: generateVariantsWithPrefix<typeof textColors>(
      textColors,
      '&:hover',
    ),
  },

  defaultVariants: {
    size: 'md',
    color: 'text1',
  },
})
